module.exports = __webpack_public_path__ + "img/7.01ad469d.jpg";